import "./KBaseMapInfoWindow.scss";
import { MapElementMixin, gmapApi } from "vue2-google-maps";
import {
	VAlert,
	VContainer,
	VProgressCircular
} from "vuetify/lib";

export default {
	name: "KBaseMapInfoWindow",

	inject: [
		"markerPosition",
		"storeModuleName"
	],

	props: {
		autoPan: Boolean,
		inactiveOnClose: Boolean,
		offsetX: {
			default: 0,
			type: Number
		},
		offsetY: {
			default: -40,
			type: Number
		},
		showPano: Boolean
	},

	mixins: [ MapElementMixin ],

	data: vm => ( {
		options: {
			disableAutoPan: !vm.autoPan,
			maxWidth: 300,
			pixelOffset: {
				height: vm.offsetY,
				width: vm.offsetX
			}
		},
		pano: {
			error: null,
			id: null,
			loading: false,
			position: null,
			radius: 150
		}
	} ),

	computed: {
		google: gmapApi,

		panoErrorMessages() {
			const svs = this.google.maps.StreetViewStatus;

			return {
				[svs.UNKNOWN_ERROR]: "An unknown error occurred. You can try again in a moment or try refreshing the page.",
				[svs.ZERO_RESULTS]: "No imagery data available for this location"
			};
		},

		editMode() {
			return this.$store.state[this.storeModuleName].editMode;
		},

		open() {
			return !this.editMode;
		},

		genPanorama() {
			if ( !this.showPano ) {
				return;
			}

			if ( this.pano.loading ) {
				return <VContainer
					class="k-pano-loading align-center justify-center fill-height"
				>
					<VProgressCircular
						color="grey"
						indeterminate
						width={3}
					></VProgressCircular>
				</VContainer>;
			} else if ( this.pano.id ) {
				return <gmap-street-view-panorama
					class="k-pano"
					options={{
						addressControl: false,
						enableCloseButton: false,
						linksControl: false,
						motionTrackingControl: false,
						navigationControl: false,
						panControl: false,
						pano: this.pano.id,
						zoomControl: false
					}}
					position={this.pano.position}
					pov={{
						heading: 270,
						pitch: 0
					}}
				></gmap-street-view-panorama>;
			} else if ( this.pano.error && this.panoErrorMessages[this.pano.error] ) {
				return <VAlert
					text
					type="error"
				>{this.panoErrorMessages[this.pano.error]}</VAlert>;
			}
		}
	},

	watch: {
		open( open ) {
			if ( !open && this.inactiveOnClose ) {
				this.$store.dispatch( `${this.storeModuleName}/setRootActiveMarker`, null );
			}
		},

		"markerPosition.base": {
			handler( position, oldPosition ) {
				if ( oldPosition
					&& position.lat === oldPosition.lat
					&& position.lng === oldPosition.lng
				) {
					return;
				}

				const sv = new this.google.maps.StreetViewService();

				this.pano.loading = true;

				sv.getPanorama( {
					location: position,
					radius: this.pano.radius
				}, ( data, status ) => {
					this.pano.loading = false;

					if ( status === this.google.maps.StreetViewStatus.OK ) {
						this.pano.error = null;
						this.pano.id = data.location.pano;
						this.pano.position = data.location.latLng;
					} else {
						this.pano.error = status;
						this.pano.id = null;
						this.pano.position = null;
					}
				} );
			},
			immediate: true
		}
	},

	methods: {
		closeclickEvent() {
			if ( this.inactiveOnClose ) {
				this.$store.dispatch( `${this.storeModuleName}/setRootActiveMarker`, null );
			}
		}
	},

	render() {
		return <gmap-info-window
			opened={this.open}
			options={this.options}
			position={this.markerPosition.spiderfied}
			onCloseclick={this.closeclickEvent}
		>
			{this.genPanorama}
			{this.$slots.default}
		</gmap-info-window>;
	}
};
